module.exports = __webpack_public_path__ + "img/mongodb.b089d237.png";